import React from "react";
import {useSelector} from "react-redux";
const SavingLock = (props) => {
    const saving = useSelector(state => state.configuratorStateReducer.saving);
    const styles = {
        body: {
            position: 'fixed',
            top: '0px',
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255, 0.6)',
            zIndex: 999
        },
        spinner: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
        },
        text: {
            marginTop: '5px'
        }
    }
    if(!saving){
        return null;
    }

    return (
        <div style={styles.body}>
            <div style={styles.spinner} className={'fa-3x'}>
                <i className="fa fa-spinner fa-spin"/>
                <h4 style={styles.text}>Saving</h4>
            </div>
        </div>
    )

}

export default SavingLock;